export default __webpack_public_path__ + "static/our-values-1-311a1cd5ddb1631a99991817afbda9f7.svg";